<template>
    <div>
        <div class="btn-add-application d-flex justify-content-start mr-3">
            <div class="kpi-filter m-4" style="outline: rgba(108, 108, 108, 1)">
                <label for=""><b>Thời gian</b></label
                ><br/>
                <el-date-picker
                    v-model="month"
                    :clearable="false"
                    class="btn-outline-secondary rounded w-100"
                    placeholder="Chọn tháng"
                    size="small"
                    type="month"
                    value-format="yyyy-MM"
                    @change="getListMonthlyResult()"
                >
                </el-date-picker>
            </div>
        </div>
        <div class="example-preview table-responsive">
            <table v-loading="loading" class="table table-vertical-center table-bordered kpi-table"
                   element-loading-text="Loading...">
                <thead>
                <tr style="background-color: #F8F8F8;">
                    <th>KRAs</th>
                    <th>Yêu cầu thành phẩm</th>
                    <th>Nhập thành phẩm</th>
                    <th style="width:8%">Trọng số</th>
                    <th>Trạng thái</th>
                    <th>Kết quả KRA</th>
                </tr>
                </thead>
                <tbody v-if="data?.details?.data">
                <tr v-for="(item, index) in data?.details?.data" :key="item.id">
                    <td>
                        <div class="breaking-text">{{ item.name.trim() ?? '' }}</div>
                    </td>
                    <td>
                        <div class="breaking-text">{{ item.request_result.trim() ?? '' }}</div>
                    </td>
                    <td style=" width:25%">
                        <div class="d-flex">
                            <el-input type="textarea"
                                      :rows="2" v-model="item.results" disabled></el-input>
                        </div>
                        <div class="text-danger mt-2" v-if="resultsError[item.id]">{{ resultsError[item.id] }}</div>
                        <div class="text-success mt-2" v-if="resultsSuccess[item.id]">{{ resultsSuccess[item.id] }}</div>
                    </td>
                    <td> {{ item.percent_score + '%' ?? '' }}</td>
                    <td style="text-align:-webkit-center; width:6%">
                        <div :style="statusKpiCss[item.status]" class="text-white rounded p-1 text-center"
                             style="width:100px"> {{ statusKpi[item.status] }}
                        </div>
                    </td>
                    <td>
                        {{
                            item.percent_results >= 0 && item.percent_results !== null ? item.percent_results + '%' : 'Chưa có'
                        }}
                    </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="text-center">
                    <td colspan="7">
                        Không có dữ liệu
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {SHOW_DATA_KPI_PERSIONAL} from "../../../../core/services/store/kpi/kpi.module";
import {mapGetters, mapState} from "vuex";

export default {
    name: "KpiStaff",
    data()
    {
        return {
            page: 1,
            last_page: 1,
            activeName: "kpi",
            month: "",
            loading: false,
            data: [],
            resultsError: {},
            resultsSuccess: {},
            statusKpiCss: {
                0: "background-color: rgba(255, 0, 0, 1); text-white",
                1: "background-color: rgba(0, 128, 13, 1); text-white",
            },
            statusKpi: {
                0: "Cần nhập",
                1: "Đã nhập",
            },
        }
    },
    mounted() {
        this.getMonthCurrent();
        this.getListMonthlyResult();
    },
    methods: {
        getMonthCurrent() {
            let currentDate = this.$moment()
            if (currentDate.date() <= 10) {
                this.month = currentDate.subtract(1, 'month').format('YYYY-MM')
            } else {
                this.month = currentDate.format('YYYY-MM')
            }
        },
        getListMonthlyResult() {
            const user_id = this.currentUser.id;
            if (!user_id) {
                this.$message({
                    type: 'error',
                    message: 'Không tìm thấy user',
                    showClose: true
                })
                return;
            }
            this.$store.dispatch(SHOW_DATA_KPI_PERSIONAL, {
                page: this.page,
                user_id,
                month: this.month,
            }).then((res) => {
                this.data = res.data;
                this.last_page = res.data.details.last_page;
            }).catch(() => {

            })
        },
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser'])
    },
}
</script>

<style scoped>
.kpi-filter {
    width: 260px;
    max-width: calc(100vw - 48px);
}

.kpi-table {
    min-width: 900px;
}

.breaking-text {
    overflow-wrap: anywhere;
}

@media (max-width: 575.98px) {
    .btn-add-application {
        margin-right: 0 !important;
    }

    .kpi-filter {
        margin: 0 0 16px 0 !important;
        width: 100%;
        max-width: 100%;
    }

    .kpi-table {
        min-width: 760px;
    }
}
</style>
